// extracted by mini-css-extract-plugin
module.exports = {"Label":"EditArticle_Label__1B1Vz","FeatureImg":"EditArticle_FeatureImg__hkh8o"};